import React from 'react';
import { formatDeadline } from '../utils/tipLabels';
import { teamLogoFromMatch } from '../utils/teamLogo';
import TeamCrest from './TeamCrest';

const MatchTipCard = ({
  match: m,
  drafts,
  setDrafts,
  saving,
  messages,
  onSubmit,
}) => (
  <div className="match-tip-card">
    <div className="match-tip-meta">
      {m.kickoffAt && (
        <span>
          {new Date(m.kickoffAt).toLocaleString('de-DE', {
            weekday: 'short',
            day: '2-digit',
            month: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </span>
      )}
      {m.tipDeadlineAt && (
        <span className="match-tip-deadline">
          Deadline {formatDeadline(m.tipDeadlineAt)}
        </span>
      )}
    </div>

    <div className="match-tip-row">
      <div className="match-tip-home">
        <TeamCrest src={teamLogoFromMatch(m, 'home')} alt={m.homeTeamName} />
        <span className="match-tip-name">{m.homeTeamName}</span>
      </div>

      <div className="match-tip-scores">
        <input
          type="number"
          min={0}
          max={99}
          step={1}
          className="input-score match-tip-input"
          value={drafts[m._id]?.home ?? ''}
          onChange={(e) => setDrafts({
            ...drafts,
            [m._id]: { ...drafts[m._id], home: e.target.value },
          })}
          aria-label={`Tipp ${m.homeTeamName}`}
        />
        <span className="match-tip-colon">:</span>
        <input
          type="number"
          min={0}
          max={99}
          step={1}
          className="input-score match-tip-input"
          value={drafts[m._id]?.away ?? ''}
          onChange={(e) => setDrafts({
            ...drafts,
            [m._id]: { ...drafts[m._id], away: e.target.value },
          })}
          aria-label={`Tipp ${m.awayTeamName}`}
        />
      </div>

      <div className="match-tip-away">
        <span className="match-tip-name">{m.awayTeamName}</span>
        <TeamCrest src={teamLogoFromMatch(m, 'away')} alt={m.awayTeamName} />
      </div>
    </div>

    <div className="match-tip-actions">
      <button
        type="button"
        className="btn-wacker btn-wacker--sm"
        disabled={saving[m._id]}
        onClick={() => onSubmit(m._id)}
      >
        {saving[m._id] ? '…' : m.myTip ? 'Aktualisieren' : 'Speichern'}
      </button>
      {m.myTip && (
        <span className="match-tip-saved">Gespeicherter Tipp vorhanden</span>
      )}
    </div>

    {messages[m._id] && (
      <p className={`match-tip-message ${messages[m._id].includes('gespeichert') ? 'is-success' : 'is-error'}`}>
        {messages[m._id]}
      </p>
    )}
  </div>
);

export default MatchTipCard;
